import { formatImageUrl, VehicleMedia } from "@alba-cars/common-modules";
import { Navigation, Virtual } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import OptimizedImage from "@/components/common/images/OptimizedImage";
import { DEFAULT_PLACEHOLDER } from "@/utils/constants";

interface MobileSwiperProps {
  images: VehicleMedia[];
  altText: string;
  onImageClick: (index: number) => void;
}

const MobileSwiper: React.FC<MobileSwiperProps> = ({ images, altText, onImageClick }) => {
  return (
    <div className="relative lg:hidden">
      {/* Container with no overflow hidden to allow buttons to extend beyond */}
      <div className="rounded-2xl">
        <Swiper
          modules={[Navigation, Virtual]}
          navigation={{
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
          }}
          preventInteractionOnTransition={true}
          virtual={{
            addSlidesAfter: 1,
            addSlidesBefore: 1,
            enabled: true,
          }}
          slidesPerView={1}
          spaceBetween={16}
          className="overflow-hidden rounded-2xl"
        >
          {images.map((image, idx) => (
            <SwiperSlide key={image.id}>
              <div className="relative aspect-[4/3] overflow-hidden rounded-2xl">
                <OptimizedImage
                  src={formatImageUrl(image.mediaUrl) ?? DEFAULT_PLACEHOLDER}
                  alt={altText}
                  className="h-full w-full object-cover object-center"
                  imageLayout="custom"
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                  loading={idx < 3 ? "eager" : "lazy"}
                  priority={idx < 3}
                  fetchPriority={idx < 3 ? "high" : "auto"}
                  onClick={() => onImageClick(idx)}
                  width={300}
                  height={625}
                  maxWidth={800}
                  placeholder={"blur"}
                  blurDataURL={DEFAULT_PLACEHOLDER}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Left navigation button positioned exactly half on/half off */}
      {/* <button
        className="swiper-prev absolute left-0 top-1/2 z-30 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white text-black shadow-xl hover:bg-gray-50 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 sm:h-10 sm:w-10 md:h-12 md:w-12"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <IconArrowRight height="14" width="14" className="md:h-18 md:w-18 rotate-180 sm:h-16 sm:w-16" />
      </button> */}

      {/* Right navigation button positioned exactly half on/half off */}
      {/* <button
        className="swiper-next absolute right-0 top-1/2 z-30 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white text-black shadow-xl hover:bg-gray-50 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 sm:h-10 sm:w-10 md:h-12 md:w-12"
        style={{ transform: "translate(50%, -50%)" }}
      >
        <IconArrowRight height="14" width="14" className="md:h-18 md:w-18" />
      </button> */}
    </div>
  );
};

export default MobileSwiper;
